import Button from "./Button";
import Card from "./Card";
import Link from "./Link";
import Modal from "./Modal";
import Progress from "./Progress";
import Heading from "./Heading";

export default {
  Button,
  Card,
  Modal,
  Progress,
  Link,
  Heading
};
